import axios from '@/plugins/axios';
import ErrorHandle from '@/helpers/errors/errorHandle';
import { JSONpath } from '@/helpers/JSONpath';
import { decrypt } from '@/helpers/decrypt';

const initialState = {
  locale: { key: 'ru', title: 'Русский', icon: 'russian-flag' },
  languages: [
    { key: 'ru', title: 'Русский', icon: 'russian-flag' },
    { key: 'kk', title: 'Қазақша', icon: 'kazakh-flag' },
  ],
  role: '',
  loader: false,
  alertError: {
    state: false,
    message: '',
  },
  alertSuccess: {
    state: false,
    message: '',
  },
  miniSidebar: false,
  drawerSidebar: true,
  showImageViewer: false,
  imageViewerLink: null,
  imagesUploading: [],
};

const getters = {
  getLocale: (state) => state.locale,
  getLanguages: (state) => state.languages,
  getRole: (state) => state.role,
  getLoader: (state) => state.loader,
  getAlertError: (state) => state.alertError,
  getAlertSuccess: (state) => state.alertSuccess,
  getMiniSidebar: (state) => state.miniSidebar,
  getDrawerSidebar: (state) => state.drawerSidebar,
  getImageViewer: (state) => state.showImageViewer,
  getImageViewerLink: (state) => state.imageViewerLink,
  getImagesUploadingLength: (state) => state.imagesUploading.length,
};

const mutations = {
  setLocale(state, data) {
    state.locale[data.lang] = data.data;
  },
  setLanguages(state, data) {
    state.languages = data;
  },
  setAlertError(state, error) {
    state.alertError = error;
  },
  clearAlertError(state) {
    state.alertError = {
      state: false,
      message: '',
    };
  },
  setAlertSuccess(state, alert) {
    state.alertSuccess = alert;
  },
  clearAlertSuccess(state) {
    state.alertSuccess = {
      state: false,
      message: '',
    };
  },
  setRole(state) {
    const myInfo = localStorage.getItem('me');
    if (myInfo) {
      const myInfoData = JSON.parse(myInfo);

      // Decrypt role
      const decryptedRole = decrypt(
        myInfoData.role,
        myInfoData.id + myInfoData.createdAt,
      );

      // Store roles at state
      state.role = decryptedRole;
    } else {
      state.role = '';
    }
  },
  setLoader(state, payload) {
    state.loader = payload;
  },
  setMiniSidebar(state, payload) {
    state.miniSidebar = payload;
  },
  setDrawerSidebar(state, payload) {
    state.drawerSidebar = payload;
  },
  setImageViewer(state, payload) {
    state.showImageViewer = payload;
  },
  setImageViewerLink(state, payload) {
    state.imageViewerLink = payload;
  },
  setImageUploader(state, payload) {
    const { uploaderHash, isUploading } = payload;
    const { imagesUploading } = state;
    if (isUploading) {
      let isSetUploader = false;
      imagesUploading.forEach((uploader, index) => {
        if (uploader.hash === uploaderHash) {
          imagesUploading[index].isUploading = true;
          isSetUploader = true;
        }
      });
      if (!isSetUploader) {
        imagesUploading.push({
          hash: uploaderHash,
          isUploading,
        });
      }
    } else {
      imagesUploading.forEach((uploader, index) => {
        if (uploader.hash === uploaderHash) {
          imagesUploading.splice(index, 1);
        }
      });
    }
  },
};

const actions = {
  async fetchLocaleData({ commit }, credentials) {
    const lang = credentials.lang
      ? credentials.lang
      : process.env.VUE_APP_DEFAULT_LOCALE;
    try {
      const data = await axios.get(`${JSONpath()}/${lang}.json`);
      const localeData = data.data;

      commit('setLocale', { lang: credentials.lang, data: localeData });
      return localeData;
    } catch (error) {
      return error.response;
    }
  },
  // eslint-disable-next-line
  async uploadPhotos({ commit }, formData) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const response = await axios.post('/images-upload', formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          Lang: lang,
          'Content-type': 'multipart/form-data',
        },
      });
      if (response.data.success) {
        return response.data.data.images;
      }
      if (response.data.error.message) {
        throw new Error(response.data.error.message);
      }
      throw new Error(`Api error: ${response.status}`);
    } catch (error) {
      throw ErrorHandle(error, this);
    }
  },

  async uploadVideo(_, formData) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const { data } = await axios.post('/videos-upload', formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          Lang: lang,
          'Content-type': 'multipart/form-data',
        },
      });

      return data.data.videos[0];
    } catch (error) {
      return error;
    }
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};
